module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"payment_search":"Поиск по платежам"},"en":{"payment_search":"Payments search"}}')
  delete Component.options._Ctor
}
